module.exports = __webpack_public_path__ + "static/flags/SK-24494d200bc866b14384881337bdc497.gif";